module.exports = __webpack_public_path__ + "static/media/Icon metro-cross.94032e51.svg";